export const INTERN_PROFILE = "Intern_Profile";
export const GIT_ISSUES = "Git_Issues";
export const PULL_REQUESTS = "Pull_Requests";
export const PRESENTATIONS_OR_WEBINARS = "Presentations_Or_Webinars";
export const BLOGS = "Blogs";
export const PROJECTS = "Projects";
export const PROJECT_TASKS = "Project_Tasks"
export const ROLES = "Roles";
